import { PageBuilderProvider } from "./core/context/PageBuilderContext";
import { PageBuilderTopBar } from "./core/editor/PageBuilderTopBar";
import { PageBuilderLeftPanel } from "./core/editor/PageBuilderLeftPanel";
import { PageBuilderCanvas } from "./core/editor/PageBuilderCanvas";
import { PageBuilderRightPanel } from "./core/editor/PageBuilderRightPanel";
import { ProjectBootstrap } from "./project/init";
import { ProjectProvider } from "./project/context/ProjectContext";

export function PageBuilderEditor() {
    return (
        <PageBuilderProvider>
            <ProjectProvider>
                <ProjectBootstrap />
                <div style={containerStyle}>
                    <PageBuilderTopBar />
                    <div style={mainStyle}>
                        <PageBuilderLeftPanel />
                        <div style={canvasWrapperStyle}>
                            <PageBuilderCanvas />
                        </div>
                        <PageBuilderRightPanel />
                    </div>
                </div>

            </ProjectProvider>
        </PageBuilderProvider>

    );
}

const containerStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    width: "100%",
    backgroundColor: "var(--fx-surface-muted, #F1F5F9)",
    overflow: "hidden",
};

const mainStyle: React.CSSProperties = {
    display: "flex",
    flex: 1,
    overflow: "hidden",
};

const canvasWrapperStyle: React.CSSProperties = {
    flex: 1,
    overflow: "hidden",
    position: "relative",
};
